import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Breakpoints, BreakpointObserver } from '@angular/cdk/layout';
import { map, Observable, pluck } from 'rxjs';
import { UserReport, UserService } from 'src/app/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-user-dashboard',
  templateUrl: './user-dashboard.component.html',
  styleUrls: ['./user-dashboard.component.scss'],
})
export class UserDashboardComponent {
  public isHandset = this.breakpointObserver.observe(Breakpoints.Handset);
  public dashboardInfo = this.userService.generateDashboardReportData();
  public userReport: Observable<UserReport> = this.router.data.pipe(
    map((report) => report['user'])
  );
  async ngOnInit() {}

  constructor(
    protected breakpointObserver: BreakpointObserver,
    private userService: UserService,
    private router: ActivatedRoute,
    private snackbar: MatSnackBar,
  ) {
    router.data.subscribe((data) => {});
    this.userService.getReferreds().subscribe(res => {
      console.log(res);
    })
  }
  referralLink = '';

  getReferralCode() {
    this.userService.getReferralObject().subscribe({next: (res: any) => {
      if (res?.referralLink) this.referralLink = res.referralLink;
    }})
  }

  copyLink() {
    this.snackbar.open('لینک دعوت کپی شد.', 'باشه', {
      duration: 1500,
    });
  }
}
